import { IDiemKyHieuActionTypes } from "../../action-types/category/IDiemKyHieuActions";
import { IDiemKyHieuReducer } from "../../reducer-model/category/IDiemKyHieuReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const iniState: IDiemKyHieuReducer = {
    status: eReducerStatusBase.is_not_initialization,
    diemKyHieus: [],   
}
export const DiemKyHieuReducer = (state: IDiemKyHieuReducer = iniState, action: IDiemKyHieuActionTypes): IDiemKyHieuReducer => {
    switch (action.type) {
        case "DIEM_KY_HIEU_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "DIEM_KY_HIEU_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                diemKyHieus: action.payload,
            };
        case "DIEM_KY_HIEU_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "DIEM_KY_HIEU_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                diemKyHieuEdit: action.payload,
            };
        case "DIEM_KY_HIEU_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            };
        case "DIEM_KY_HIEU_SAVE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving,
            };
        case "DIEM_KY_HIEU_SAVE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
                isShowEditModal: false,
            };
        case "DIEM_KY_HIEU_SAVE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "DIEM_KY_HIEU_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting,
            };
        case "DIEM_KY_HIEU_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "DIEM_KY_HIEU_DELETE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        default:
            return state;
    }
}